import React from 'react';
import PropTypes from 'prop-types';
import styles from './FAQSections.pcss';
import {Message} from 'epic-diesel-common';
import root from 'window-or-global';
import ConductDialog from '../../eula/ConductDialog';
import eulaActions from '../../../actions/eula.actions';
import {connect} from 'react-redux';

const mapDispatchToProps = {
    fetchConduct: eulaActions.getConductAgreement
};

class FAQSection extends React.Component {
    static propTypes = {
        sectionData: PropTypes.object,
        fetchConduct: PropTypes.func
    };
    static defaultProps = {
        sectionData: {}
    };
    state = {
        showEula: false
    };

    componentDidMount() {
        /**
         * TODO: Eventually make a smart wrapper for content which looks for
         * specific attributes to open dialogs or a custom element.
         */
        root.__EPIC_SHOW_CODE_OF_CONDUCT_DIALOG = this.showEula;
        this.props.fetchConduct();
    }

    componentWillUnmount() {
        delete root.__EPIC_SHOW_CODE_OF_CONDUCT_DIALOG;
    }

    showEula = () => {
        this.setState({showEula: true});
    };

    closeEula = () => {
        this.setState({showEula: false});
    };

    render() {
        const {sectionData} = this.props;
        const faq = sectionData.faq || [];
        let faqItem = [];

        if (faq) {
            faqItem = faq.faqItem || [];
        }
        return (
            <div className={styles.section}>
                <div className={styles.container}>
                    <h2>
                        <Message code="epic.affiliate.overview.faq" />
                    </h2>
                    <ConductDialog open={this.state.showEula} onClose={this.closeEula} />
                    {faqItem.map((item, key) => (
                        <div id={item.anchor} className={styles.detail} key={key}>
                            <h6>{item.title}</h6>
                            <div dangerouslySetInnerHTML={{__html: item.answer}} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default connect(
    undefined,
    mapDispatchToProps
)(FAQSection);
